import { BATCH_SIZE, FLUSH_INTERVAL_MS, MAX_RETRY } from './constants';
import { beaconReportEvents, reportEvents } from './report';
import { isTrackDebugEnabled } from './utils';

/**
 * 埋点事件内存队列，负责批量冲刷与失败重试
 */
export class EventQueue {
  constructor(flushHandler = reportEvents) {
    this.queue = [];
    this.timer = null;
    this.flushing = false;
    this.retryCount = 0;
    this.flushHandler = flushHandler;
  }

  /**
   * 启动定时冲刷
   */
  start() {
    if (this.timer) {
      return;
    }

    this.timer = setInterval(() => {
      this.flush(false);
    }, FLUSH_INTERVAL_MS);
  }

  /**
   * 停止定时冲刷
   */
  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  /**
   * 入队
   */
  push(event) {
    this.queue.push(event);

    if (this.queue.length >= BATCH_SIZE) {
      this.flush(false);
    }
  }

  /**
   * 获取当前队列长度
   */
  size() {
    return this.queue.length;
  }

  /**
   * 冲刷队列
   */
  async flush(useBeacon = false) {
    if (this.flushing || !this.queue.length) {
      return;
    }

    const events = this.queue.splice(0, BATCH_SIZE);
    this.flushing = true;

    try {
      if (useBeacon) {
        const ok = beaconReportEvents(events);
        if (!ok) {
          this.requeue(events);
        }
        return;
      }

      await this.flushHandler(events);
      this.retryCount = 0;

      if (isTrackDebugEnabled()) {
        console.log('[Tracker] flush success', events.length);
      }
    } catch (e) {
      this.requeue(events);
      this.retryCount += 1;

      if (isTrackDebugEnabled()) {
        console.warn('[Tracker] flush failed', e);
      }
    } finally {
      this.flushing = false;
    }
  }

  /**
   * 失败事件回退队列
   */
  requeue(events) {
    if (this.retryCount >= MAX_RETRY) {
      if (isTrackDebugEnabled()) {
        console.warn('[Tracker] drop events after retry limit', events);
      }
      return;
    }

    this.queue = events.concat(this.queue);
  }
}
